<template>
    <fieldset class="cms-buttons-container">
        <legend v-html="title"></legend>

        <span :class="{active: width == 12}" class="cms-option-button large" v-on:click="$emit('set-width', 12)">
            <span><i class="fa fa-arrows-alt"></i></span>
            {{ $t('full_width') }}
        </span>
        <span :class="{active: width == 6}" class="cms-option-button large" v-on:click="$emit('set-width', 6)">
            <span>&frac12;</span>
            {{ $t('half_width') }}
        </span>
        <span :class="{active: width == 4}" class="cms-option-button large" v-on:click="$emit('set-width', 4)">
            <span>&frac13;</span>
            {{ $t('one_third') }}
        </span>
        <span :class="{active: width == 8}" class="cms-option-button large" v-on:click="$emit('set-width', 8)">
            <span> &#8532;</span>
            {{ $t('two_thirds') }}
        </span>
        <span :class="{active: width == 3}" class="cms-option-button large" v-on:click="$emit('set-width', 3)">
            <span>&frac14;</span>
            {{ $t('quarter_width') }}
        </span>
        <span class="cms-option-button large" v-on:click="$emit('set-width', 0)" v-if="!individual">
            <span><i class="fa fa-arrows-h"></i></span>
            {{ $t('separator') }}
        </span>
        <span class="cms-option-button large" v-on:click="$emit('destroy')" v-if="individual">
            <span><i class="fa fa-trash"></i></span>
            {{ $t('delete') }}
        </span>
        <span class="cms-option-button large" v-tooltip="$t(altLocaleCopyText)" v-on:click="$emit('copy', alternateLocale)" v-if="individual">
            <span><i class="fa fa-copy"></i></span>
            {{ $t('copy') }}
        </span>
    </fieldset>
</template>

<script>
    export default {
        props: {
            individual: {
                type: Boolean,
                default: false,
            },
            width: Number,
            title: String,
        },
        computed: {
            alternateLocale: function () {
                return document.locales.find(locale => locale != document.locale);
            },

            altLocaleCopyText: function () {

                return 'copy_to_' + this.alternateLocale;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/helpers/BlockOptions.vue